<template>
  <div>
    <cebianlan></cebianlan>
    <!-- 头部 -->
    <banner></banner>
    <!-- 轮播图 -->
    <div style=" min-width: 972px;overflow: hidden; background-color: #f5f6f7" class="lunboBanner">
      <CarouselPic/>
        <div style="overflow: hidden" class="quality-course">
        <div style="margin: 0 auto; width: 244px; height: 36px; margin-top: 60px; overflow: hidden">
          <img class="zuo" src="./images/zuo@2x.png" alt="" />
          <span class="gongkai" style="margin-left: 20px">1V1约课</span>
          <img class="zuo" style="margin-left: 20px" src="./images/you@2x.png" alt="" />
        </div>
        <div class="onePersonClass">
        <ul class="course-content">
        <li class="course-item" v-for="item in list" :key="item.id">
        <div class="course-img">
          <img :src="item.cover" alt="" />
        </div>
        <div class="course-desc">
          <h4 class="course-title">{{ item.name }}</h4>
        <div class="course-time" v-if="item.start_time">
            上课时间
            <span>{{ item.start_time.substring(0, 16) }}</span>
        </div>
        <div class="course-time-block" v-else></div>
        </div>
        <div class="study-state">
          <div class="study-time not-begin" v-if="!Number(item.endNum)">未开始学习</div>
          <div class="complete-study study-time" v-else></div>
          <div class="start-study" @click="handleStartStudy(item)">开始学习</div>
        </div>
        </li>
        </ul>
        <div class="pagination" v-show="pagination.total">
           <el-pagination background  :current-page="pagination.page" @current-change="handleCurrentChange" :page-size="8" layout="total, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
        </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import banner from './banner'
import Footer from './mofang/footer.vue'
import CarouselPic from './components/carouselPic.vue'
import cebianlan from './cebianlan'
export default {
   data() {
    return {
      pagination: {
        page: 1,
        total: 0,
        num: 8,
      },
      curType: 0,
      list: [],
    }
  },
   components: {
    banner,
    Footer,
    cebianlan,
    CarouselPic
  },
   created() {
    this.getCourseList()
  },
  methods: {
    async getCourseList() {
      const data = {
        page: this.pagination.page,
        num: this.pagination.num,
      }
      const res = await this.$axios.post('stu/course/my1V1Courses', data)
      if (res.data.status === 'success') {
        const listObj = res.data.data
        this.list = listObj.list
        this.pagination.total = listObj.count
      }
    },
    changeCourseType(idx) {
      this.curType = idx
      this.pagination.page = 1
      this.getCourseList()
    },
    handleCurrentChange(val) {
      this.pagination.page = val
      this.getCourseList()
    },
    // 跳转到课程详情
    handleStartStudy(val) {
      this.$router.push({ path: '/oneclass/',
      query: {
        id: val.course_id
      }})

    },
  },
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.quality-course {
  margin-bottom: 60px;
  min-width: 972px;
  background: #f5f6f7;
}
.zuo {
  height: 22px;
  width: 38px;
  float: left;
  margin-top: 7px;
}
.gongkai {
  float: left;
  opacity: 1;
  font-size: 32px;
  font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
  font-weight: 700;
  text-align: left;
  color: #202020;
  line-height: 36px;
}
.wrap1 {
  background: #ffffff;
  margin: 25px 0px 25px 25px;
  float: left;
  padding: 20px 30px;
  height: 880px;
}
.title {
  font-size: 20px;
  color: #202020;
  padding-bottom: 17px;
  border-bottom: 1px solid #e8eaec;
}
.course-categories {
  margin: 20px 0;
}
.course-type {
  width: 84px;
  height: 34px;
  display: inline-block;
  line-height: 34px;
  color: #202020;
  font-size: 14px;
  text-align: center;
  border-radius: 17px;
  margin-right: 20px;
  cursor: pointer;
  transition: all 0.5s;
}
.active {
  background: #10a675;
  color: #ffffff;
}
.course-content {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
}
.course-item {
  border-radius: 4px;
  width: 300px;
  height: 320px;
  margin: 0 10px 20px 10px;
  background: #fff;
}

.course-img {
  position: relative;
  width: 100%;
  height: 200px;
  margin-bottom: 16px;
  overflow: hidden;
  border-radius: 4px 4px 0px 0px;
}
ul li {
  list-style-type: none;
}
.course-img img {
  width: 100%;
  height: 100%;
}
.course-desc {
  padding: 0 20px;
  margin-bottom: 10px;
}
.course-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 500;
  color: #20242f;
  margin-bottom: 9px;
}
.course-time {
  font-size: 14px;
  color: #808695;
}
.course-time-block {
  height: 18px;
}
.course-time .course-time span {
  margin-right: 10px;
}
.study-state {
  display: flex;
  padding: 0 20px;
  justify-content: space-between;
}
.study-state div {
  width: 91px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  border-radius: 17px;
  font-size: 14px;
}
.study-state .study-time {
  text-align: left;
}
.complete-study {
  color: #808695;
}
.not-begin {
  color: #FFC102;
}
.studying {
  color: #1872ED;
}
.start-study {
  border: 1px solid #1872ED;
  color: #1872ED;
  cursor: pointer;
}
.pagination {
  display: flex;
  width: 100%;
  justify-content: end;
}
.pagination >>> .el-pager li:not(.disabled).active {
  background: linear-gradient(135deg,#73aaff 5%, #0053ff 95%);
}
.onePersonClass{
  margin: 0 auto;
  margin-top: 43px;
  min-height: 200px;
  overflow: hidden;
}
</style>
